import { MASTER_LOGGED_OUT_ACTION_TYPE } from 'store/auth/actions';

import { COMPANY_PROPERTIES_NEW_ACTION_TYPE } from '../actions';

const initialState = {};

// Tracks which companies' property fetches have SETTLED (success or failure), separately
// from the data slice: consumers that WAIT on the fetch (the EnableCrm routing gates) read
// this map, while data consumers (the admin Company Properties tab's load-once guard) keep
// reading the data slice — so a failed boot fetch never masquerades as an empty result.
const companyPropertiesSettledReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_PROPERTIES_NEW_ACTION_TYPE.GET_COMPANY_PROPERTIES:
    case COMPANY_PROPERTIES_NEW_ACTION_TYPE.SETTLE_COMPANY_PROPERTIES:
      return { ...state, [payload.companyId]: true };

    case MASTER_LOGGED_OUT_ACTION_TYPE:
      return initialState;

    default:
      return state;
  }
};

export default companyPropertiesSettledReducer;
